module.exports = __webpack_public_path__ + "resource/img/image043Dark.f23b1d96.png";